import { useEffect } from 'react';
import uuid from 'react-uuid';

import BasicInfoForm from '@/components/SignUp/BasicInfoForm/BasicInfoForm';
import CompanyInfoForm from '@/components/SignUp/CompanyInfoForm/CompanyInfoForm';
import EducationInfoForm from '@/components/SignUp/EducationInfoForm/EducationInfoForm';
import SignUpComplete from '@/components/SignUp/SignUpComplete/SignUpComplete';
import { useSignUpStore } from '@/components/SignUp/SignUpContext/SignUpContext';
import Terms from '@/components/SignUp/Terms/Terms';
import useIsMobile from '@/hooks/useIsMobile';

import * as S from './style';

const SignUpContent = () => {
	const { updateTerms, terms, currentStep, setStep, currentLastStep, clearData, clearStep } = useSignUpStore();
	const isMobile = useIsMobile(900);

	const tabMenu = ['회원약관 동의', '기본정보 입력', '직장정보 입력', '학력정보 입력', '회원가입 완료'];

	useEffect(
		() => () => {
			clearData();
			clearStep();
		},
		[]
	);

	return (
		<main>
			<S.Container>
				<S.Title>회원가입</S.Title>
				{!isMobile && (
					<S.MenuBoxList>
						{tabMenu.map((item, index) => (
							<S.MenuBox
								key={index}
								className={currentStep === tabMenu[index] ? 'active' : ''}
								style={{
									cursor: index <= tabMenu.indexOf(currentLastStep) && tabMenu.indexOf(currentLastStep) !== tabMenu.length - 1 ? 'pointer' : 'not-allowed',
								}}
								onClick={() => {
									const lastStepIndex = tabMenu.indexOf(currentLastStep);

									if (index <= lastStepIndex && lastStepIndex !== tabMenu.length - 1) {
										setStep(item);
									}
								}}
							>
								<p>Step0{index + 1}</p>
								<p className="sub_title">{item}</p>
							</S.MenuBox>
						))}
					</S.MenuBoxList>
				)}
				{isMobile && (
					<S.MenuMobileBoxList>
						{tabMenu.map((item, index) => (
							<S.MenuMobileBox key={uuid()} className={currentStep === tabMenu[index] ? 'active' : ''}>
								<p>0{index + 1}</p>
							</S.MenuMobileBox>
						))}
					</S.MenuMobileBoxList>
				)}

				{currentStep === tabMenu[0] && (
					<Terms
						serviceAgree={terms.serviceAgree ?? false}
						privacyAgree={terms.privacyAgree ?? false}
						handleServiceAgree={(value) => updateTerms({ serviceAgree: value, privacyAgree: terms.privacyAgree })}
						handlePrivacyAgree={(value) => updateTerms({ privacyAgree: value, serviceAgree: terms.serviceAgree })}
					/>
				)}

				{currentStep === tabMenu[1] && <BasicInfoForm />}
				{currentStep === tabMenu[2] && <CompanyInfoForm />}
				{currentStep === tabMenu[3] && <EducationInfoForm />}
				{currentStep === tabMenu[4] && <SignUpComplete />}
			</S.Container>
		</main>
	);
};

const SignUp = () => <SignUpContent />;

export default SignUp;
